import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
	setModoTela, initForm
} from './incubacaoAvaliacaoActions';
import consts from '../consts';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class IncubacaoAvaliacaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard
						style={{
							marginTop: 20,
							backgroundColor: '#0F2748',
							color: '#ffffff',
							borderRadius: 20,
							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
							opacity: '80%'
						}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.formularioValues.id ? 'Banca de Incubação' : 'Crie uma nova banca incubação'}</label>
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
									<Field
										name='processo'
										component={LabelAndInput}
										label='Nome do Processo Seletivo: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Grid cols='12 12 12 12'>
										<div class='form-group'>
											<label>Nome da Ideia:</label>
											<div class='input-group my-colorpicker2 colorpicker-element' data-colorpicker-id='2'>
												<input type='text' class='form-control' 
													data-original-title='' title=''
													style={{ fontWeight: 'normal' }}
													value={this.state.ideia}
													onChange={data => {
														this.setState({
															ideia: data.target.value
														});
													}} />
												<div class='input-group-append'
													onClick={() => {
														let ideias = this.props.formularioValues.ideias || [];
														ideias.push((this.state.ideia || '').trim())
														this.props.initForm({
															...this.props.formularioValues,
															ideias: ideias
														});
														this.setState({
															ideia: ''
														});
													}}>
													<span class='input-group-text'><i class='fas fa-plus'></i></span>
												</div>
											</div>
										</div>
									</Grid>
									<Grid cols='12 12 12 12'>
										<div style={{ display: 'flex' , flexWrap: 'wrap', marginBottom: 24  }}>
											{(this.props.formularioValues.ideias || []).map(ideia => (
												<div key={ideia} 
													style={{
														display: 'flex',
														flexDirection: 'row',
														backgroundColor: '#ffffff',
														color: '#0F2748',
														padding: 8,
														borderRadius: 10,
														marginRight: 8, 
														marginBottom: 8
													}}>
													<div>{ideia}</div>
													<span style={{ marginLeft: 8 }}
														onClick={() => {
															let ideias = (this.props.formularioValues.ideias || []).filter(ideiaAux => ideiaAux != ideia);
															this.props.initForm({
																...this.props.formularioValues,
																ideias: ideias
															});
														}}><i class='fas fa-trash'></i></span>
												</div>
											))}
										</div>
									</Grid>
									
									<Field										
										name='finalizado'
										component={LabelAndCheckbox}
										label='Finalizado:' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text={this.props.formularioValues.id ? 'Salvar' : 'Criar'}
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('trilha') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IncubacaoAvaliacaoForm = reduxForm({form: 'incubacaoAvaliacaoForm', destroyOnUnmount: false})(IncubacaoAvaliacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('incubacaoAvaliacaoForm')(state),
	registro: state.incubacao.registro,
	lista: state.incubacao.lista,
	listaUsuario: state.incubacao.listaUsuario
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoAvaliacaoForm);
